import type { DocsState } from "@/store/docs/state";
import type { Component } from "vue";
import type { DocsLanguages } from "@/models/documentation";
import { PerspectiveViewConfig } from "@/models/perspective";

/**
 * Retrieve the Docs Drawer components to load
 * @param state - Vuex state for the Docs module.
 * @returns Docs components to load in Drawer
 */
export function getDrawerComponents(state: DocsState): Component[] {
  return state.drawerComponents;
}

/**
 * Retrieve the docs drawer update status
 * @param state - Vuex state for the docs module.
 * @returns Should the Docs Drawer Component be updated
 */
export function getUpdate(state: DocsState): boolean {
  return state.getUpdate;
}

/**
 * Retrieve the selected language from docs
 * @param state - Vuex state for the docs module.
 * @returns Should the Docs Drawer Component be updated
 */
export function getLanguage(state: DocsState): DocsLanguages | undefined {
  return state.language;
}

/**
 * Retrieve the tableConfiguration value stored in Vuex.
 * @param state - Vuex state for the Docs module.
 * @returns - The value of the tableConfiguration state.
 */
export function getTableConfiguration(state: DocsState): PerspectiveViewConfig {
  const objString = JSON.stringify(state.tableConfiguration);
  return JSON.parse(objString);
}

/**
 * Retrieve the tableSchema value stored in Vuex.
 * @param state - Vuex state for the Docs module.
 * @returns - The value of the tableSchema state.
 */
export function getTableSchema(state: DocsState): Record<string, string> {
  const objString = JSON.stringify(state.tableSchema);
  return JSON.parse(objString);
}

/**
 * Retrieve the shouldClearTable value stored in Vuex.
 * @param state - Vuex state for the Docs module.
 * @returns - The value of the shouldClearTable state.
 */
export function getShouldClearTable(state: DocsState): boolean {
  return state.shouldClearTable;
}

/**
 * Retrieve the applyConfiguration value stored in Vuex.
 * @param state - Vuex state for the Docs module.
 * @returns - The value of the applyConfiguration state.
 */
export function getApplyConfiguration(state: DocsState): boolean {
  return state.applyConfiguration;
}
